import moment from 'moment';

const service_unapproved = {
  'BL/Booking': 'doc_number',
  'Fecha (cita)': {
    field: 'requeriments',
    callback: rqs => {
      return moment(rqs[0].date).isValid() ? moment(rqs[0].date).format('DD/MM/YYYY HH:mm') : ''
    }
  },
  'Cliente': {
    field: 'company',
    callback: company => {
      return company ? company.name : ''
    }
  },
  'Depot de retiro': {
    field: 'requeriments',
    callback: rqs => {
      return rqs[0].deposit_pick ? rqs[0].deposit_pick.name : ''
    }
  },
  'Depot de de devolucion (impo) o de entrega Full (expo)': {
    field: 'requeriments',
    callback: rqs => {
      return rqs[0].deposit ? rqs[0].deposit.name : ''
    }
  },
  'Fecha de sobre estadia': {
    field: 'requeriments',
    callback: rqs => {
      return moment(rqs[0].container_expiration).isValid() ? moment(rqs[0].container_expiration).format('DD/MM/YYYY') : ''
    }
  },
  'Facturar a': {
    field: 'company',
    callback: company => {
      return company ? company.company_bill.name : ''
    }
  },
  'Solicitante': {
    field: 'applicant',
    callback: user => {
      return user ? `${user.name} ${user.last_name}` : ''
    }
  },
  'Linea naviera': {
    field: 'shipping_line',
    callback: shipping_line => {
      return shipping_line ? shipping_line.name : ''
    }
  },
  'Tipo de servicio': {
    field: 'service_type',
    callback: service_type => {
      return service_type ? service_type.name : ''
    }
  },
}

export default service_unapproved;